module.exports = __webpack_public_path__ + "images/interview-Google-2.svg";